import { React } from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import SignInPage from '../pages/SingInPage/SignInPage';
import LoggedInPage from '../pages/LoggedInPage';

function LoginRouter() {
  return (
    <Routes>
      <Route path={'sign-in'} element={<SignInPage />} />
      <Route path={'logged-in'} element={<LoggedInPage />} />
      <Route path='*' element={<Navigate to={'sign-in'} />} />
    </Routes>
  );
}

export default LoginRouter;
